function isChristmas() {
  const now = new Date()
  const month = now.getMonth()
  const day = now.getDate()

  // December 1st to December 31st OR January 1st to January 10th
  return (month === 11 && day >= 1) || (month === 0 && day <= 10)
}

export const useChristmas = () => {
  const isProduction = process.env.NEXT_PUBLIC_APP_ENV === 'production'

  return !isProduction && isChristmas()
}
